/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Addsuccess2Inputs */

const en_coinvestments_nrl_addsuccess2 = /** @type {(inputs: Coinvestments_Nrl_Addsuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Release Letters tracked successfully`)
};

/**
* | output |
* | --- |
* | "Non-Release Letters tracked successfully" |
*
* @param {Coinvestments_Nrl_Addsuccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_addsuccess2 = /** @type {((inputs?: Coinvestments_Nrl_Addsuccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Addsuccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_addsuccess2(inputs)
});
export { coinvestments_nrl_addsuccess2 as "coInvestments_nrl_addSuccess" }